import HttpClient from "@/common/boot/HttpClient"

const listarTiposServico = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  try {
    const response = await HttpClient.get('/ctrl-tipo-servico', { params: payload });
    commit('LISTAR_DADOS', response.data.data);
    return response;
  } finally {
    commit('CARREGANDO', false);
  }
}

const excluirTipoServico = async ({ commit }, payload) => {
    commit('CARREGANDO', true);

    try {
        await Promise.all(
            payload.map(item => excluir(item))
        );
    } finally {
        commit('CARREGANDO', false);
    }
}

const excluir = async(linha) => {
  const resp = await HttpClient.delete(`/ctrl-tipo-servico/${linha.id}`).then(response => { return response; });
  return resp;
}

const salvarTipoServico = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  return await HttpClient.post('/ctrl-tipo-servico', payload).then(response => {
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  });
}

const atualizarTipoServico = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  return await HttpClient.put(`/ctrl-tipo-servico/${payload.id}`, payload).then(response => {
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  })
}

const restaurarTipoServico = async ({ commit }, payload) => {
    commit('CARREGANDO', true);

    return await HttpClient.post(`/ctrl-tipo-servico/${payload}/restaurar/`).then(response => {
        return response;
    }).finally(() => {
        commit('CARREGANDO', false);
    });
}

export {
  listarTiposServico,
  excluirTipoServico,
  salvarTipoServico,
  atualizarTipoServico,
  restaurarTipoServico,
}
